module.exports = __webpack_public_path__ + "static/media/multiple-choice-columns.9ad50141.svg";